import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Icon from 'components/shared/Icon/Icon';

const AiTaskRequestResponseView = ({ html, type = '' }) => {
  return html ? (
    <div
      className="flex flex-col overflow-hidden rounded-md border border-solid border-neutral-200 bg-neutral-50 px-3 py-[10px] text-sm placeholder:text-neutral-300 focus-within:outline focus-within:!outline-2"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  ) : (
    <div className="flex h-full cursor-not-allowed flex-row items-center justify-center gap-2 overflow-hidden rounded-md border border-solid border-neutral-200 bg-neutral-50 px-3 py-[10px] text-sm placeholder:text-neutral-300 focus-within:outline focus-within:!outline-2">
      <Icon icon="close-circle-linear" />
      {`No ${type}`}
    </div>
  );
};

export default withErrorBoundary(AiTaskRequestResponseView);
